import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Container } from 'reactstrap';
import BISlogoblue from 'assets/img/bis/logo2.png'
import { useCookies } from 'react-cookie';
import CustomToast from '../utils/CustomToast';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import PageSpinner from '../components/PageSpinner';
const initialInvitationData = Object.freeze({
    id: '',
    code: '',
    email: '',
    invitation_url: '',
    invitor_email: '',
    status: '',
    invitor_name: '',
    sponsorship_agreement_name: ''
});
const PanelistAccessConfirmationPage = () => {
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };
    let query = useQuery();
    const action = query.get('action');
    const invitation_code = query.get('invitation_code');
    const sponsorship_code = query.get('sponsorship_code');
    const [cookies, setCookie, removeCookie] = useCookies(['currentUser', 'isLoggedIn', 'award_id', 'section', 'failsafe_award_id', 'userRole']);
    const currentUser = cookies.currentUser;
    const token = cookies.token;
    const userRole = cookies.userRole;
    const section = cookies.section;
    const awardId = cookies.award_id;
    const panelistId = cookies.panelist_id;
    let history = useHistory();
    const [formStatus, setFormStatus] = useState(false);
    const [invitationData, setInvitationData] = useState(initialInvitationData);
    const [invitationLoading, setInvitationLoading] = useState('loading');

    const getPanelistAward = async () => {
        return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'panelist/' + panelistId + '/award/' + awardId, {
            params: {
                user_id: currentUser,
                token: token,
            },
        });
    };

    const updatePanelistAward = async (status) => {
        return await axios.put(process.env.REACT_APP_API_ENDPOINT + 'panelist/' + panelistId + '/award/' + awardId + '?status=' + status, {
            params: {
                user_id: currentUser,
                token: token,
            },
        });
    };

    // const handleInvitationAction = async (action) => {
    //     setFormStatus(true); 

    //     try {
    //         const response = await updatePanelistAward(action);
    //         const data = response.data.data;
    //         const agreement_data = data.sponsorship_agreement;
    //         console.log(data);
    //         if (response.data.status === 'Success') {
    //             toast.success(`Invitation ${action === 'accept' ? 'accepted' : 'declined'} successfully.`);

    //             if ( action == 'accept' ) {
    //                 history.push('/sponsor/invoices?id='+ agreement_data.id + '&award_id=' + agreement_data.award_id); 
    //             } else {
    //                 history.push('/sponsor/home'); 
    //             }

    //         } else {
    //             toast.error('Something went wrong. Please try again.');
    //         }
    //     } catch (error) {
    //         console.error('Error updating invitation:', error);
    //         toast.error('Error processing your action.');
    //     } finally {
    //         setFormStatus(false);
    //     }
    // };

    const handleInvitation = (status) => {
        setFormStatus(true);
        updatePanelistAward(status).then(response => {
        const result = response.data;

        if (result.status == "Success") {
            history.push('/panelist/home');
        } else {
            toast.error('Something went wrong. Please try again.');
        }
        setFormStatus(false);
      }).catch(() => {
        setFormStatus(false);
      });
    }
   
    useEffect(() => {
        getPanelistAward().then(response => {
            const result = response.data;

            if (result) {
                if (result.data.status == 'Accepted' || result.data.status == 'Declined') {
                    history.push('/panelist/home');
                }
                setInvitationData(result.data);
                setInvitationLoading('standby');
            }
        }).catch(() => {
        });
    }, [])
    
    return (
        <>
            <ToastContainer style={{ width: '370px' }} />
            <div className="VEPbackground d-flex align-items-center pt-5 pb-5">
                <Container className="d-flex justify-content-center">
                    <Row
                        style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'white'
                        }}
                        className="login-registration-row">
                        <Col lg={12} className="pt-auto px-4" style={{ backgroundColor: '#fff' }}>
                            <div className='text-center mt-3 mb-3'>
                                <img
                                    src={BISlogoblue}
                                    className="rounded"
                                    style={{ height: 60 }}
                                    alt="logo"
                                />
                            </div>
                            <p className="text-center text-primary mb-1" style={{ fontWeight: 'bold', fontSize: '24px' }}>PANELIST ACCESS INVITATION</p>
                            {invitationLoading == 'standby' ? 
                            <>
                                <p className="text-center mb-4" style={{ fontWeight: '600' }}>You have been invited to serve as a panelist</p>
                                <p className='mb-3 text-center'>
                                    {invitationData.invitor.name} has invited you to participate as a panelist for {invitationData.award.name}
                                </p>
                                <p className='text-muted mb-3 text-center' style={{ fontSize: '14px' }}><i>As a panelist, you will be part of the award process, with responsibilities and privileges defined by the organizer.</i></p>
                                <div className='text-center mb-3'>
                                    {formStatus ?
                                        <>
                                            <button className='btn btn-link mx-3' disabled ><span class="small" style={{ fontWeight: '600' }}>DECLINE</span></button>
                                            <button className='btn btn-primary mx-3' disabled ><span class="small" style={{ fontWeight: '600' , fontSize: '16px' }}>ACCEPT INVITATION</span></button>
                                        </>
                                        :
                                        <>
                                            <button className='btn btn-link mx-3'  onClick={() => handleInvitation('Declined')}><span class="small" style={{ fontWeight: '600' }}></span>DECLINE</button>
                                            <button className='btn btn-primary mx-3' onClick={() => handleInvitation('Accepted')}><span class="small" style={{ fontWeight: '600', fontSize: '16px' }}>ACCEPT INVITATION</span></button>
                                        </>
                                    }
                                </div>
                            </>
                            :
                            <>
                                <div className="mb-3">
                                    <PageSpinner />
                                </div>
                            </>
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default PanelistAccessConfirmationPage;